module.exports = __webpack_public_path__ + "static/media/30x30-3.60c26f7e.png";